import { Mail } from 'lucide-react';

const SUPPORT_EMAIL = 'noreply@vägförening.se';

export default function SupportPage() {
  return (
    <div className="flex-1 flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-xl font-semibold text-gray-900">Support / Förbättringsförslag</h1>
        <p className="text-gray-600">
          Vi uppskattar gärna förbättringsförslag eller hjälper dig med ett problem du upplevt.
        </p>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium"
        >
          <Mail className="w-4 h-4" />
          {SUPPORT_EMAIL}
        </a>
      </div>
    </div>
  );
}
